var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",staticStyle:{"right":"30px","top":"25px"}},[_c('div',_vm._l((_vm.toasts),function(toast){return _c('toast',{key:toast.id,staticClass:"mb-4",attrs:{"toast":toast}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }